/* Zentrales Lead-Formular (snippets/al-lead-form.liquid) — EIN Handler fuer alle form[data-al-lead-form].
   Payload = alle benannten Felder + Quellfelder + market; Multi-Step: interest/situation + Nachricht-Prefix.
   Nach Erfolg genau 1x ATL.track.formSubmit({email, phone, name, industry_tag}) (Signatur: layout/theme.liquid). */
(function () {
  if (window.ALLeadForm) return;

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'ttclid'];
  var urlParams = new URLSearchParams(window.location.search);
  UTM_KEYS.forEach(function (key) {
    var val = urlParams.get(key);
    if (val) { try { sessionStorage.setItem(key, val); } catch (e) {} }
  });
  function getUtm(key) {
    var s = '';
    try { s = sessionStorage.getItem(key) || ''; } catch (e) {}
    return urlParams.get(key) || s || '';
  }
  function track() { return window.ATL && window.ATL.track; }
  function trackError(field) { var t = track(); if (t && t.leadFormError) t.leadFormError(field); }

  // Sichtbare Oberkante unter dem Sticky-Header (dynamisch gemessen, Fallback 90px)
  function headerBottom() {
    var best = -1;
    document.querySelectorAll('tk-header, sticky-header, header, .shopify-section-group-header-group, [data-sticky-header]').forEach(function (el) {
      var pos = getComputedStyle(el).position;
      if (pos !== 'sticky' && pos !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.top < 120 && r.bottom > 0 && r.bottom < 260) best = Math.max(best, r.bottom);
    });
    return best >= 0 ? best : 90;
  }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Nur scrollen, wenn die Oberkante ueber dem sichtbaren Bereich liegt; dann 16px unter den Header
  function ensureTopVisible(el) {
    if (!el) return;
    var hb = headerBottom();
    var top = el.getBoundingClientRect().top;
    if (top >= hb) return;
    window.scrollTo({ top: Math.max(0, window.pageYOffset + top - hb - 16), behavior: reduceMotion ? 'auto' : 'smooth' });
  }
  function focusNoScroll(el) { if (el && el.focus) { try { el.focus({ preventScroll: true }); } catch (e) {} } }

  function setHidden(form) {
    var su = form.querySelector('[name="source_url"]');
    if (su) su.value = window.location.href;
    UTM_KEYS.forEach(function (key) {
      var el = form.querySelector('[name="' + key + '"]');
      if (el) el.value = getUtm(key);
    });
  }

  function validateField(form, input) {
    var name = input.name;
    var isCheck = input.type === 'checkbox';
    var value = isCheck ? (input.checked ? 'x' : '') : String(input.value || '').trim();
    var ok = true;
    if (input.required && !value) ok = false;
    else if (name === 'email' && value) ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    else if (name === 'phone' && value) {
      var d = value.replace(/\D/g, '');
      ok = d.length >= 6 && !/^(\d)\1+$/.test(d);
    }
    var err = form.querySelector('[data-error="' + name + '"]');
    if (err) {
      if (!err.id && input.id) err.id = input.id + '-error';
      if (err.id) input.setAttribute('aria-describedby', err.id);
      err.classList.toggle('visible', !ok);
      if (ok) err.removeAttribute('role'); else err.setAttribute('role', 'alert');
    }
    input.classList.toggle('error', !ok);
    input.setAttribute('aria-invalid', ok ? 'false' : 'true');
    return ok;
  }

  function collect(form, isMultiStep) {
    var data = {};
    Array.prototype.forEach.call(form.elements, function (el) {
      if (!el.name || el.disabled || el.hasAttribute('data-al-skip') || el.hasAttribute('data-al-hp')) return;
      var t = el.type;
      if (t === 'submit' || t === 'button' || t === 'reset' || t === 'file') return;
      if ((t === 'checkbox' || t === 'radio') && !el.checked) return;
      var v = el.value == null ? '' : String(el.value);
      if (t !== 'hidden') v = v.trim();
      if (Object.prototype.hasOwnProperty.call(data, el.name) && (t === 'checkbox' || t === 'radio')) {
        data[el.name] = data[el.name] ? data[el.name] + ', ' + v : v;
      } else {
        data[el.name] = v;
      }
    });
    data.source_url = window.location.href;
    data.market = (window.ATL && window.ATL.market) || '';
    if (isMultiStep) {
      delete data.interest_opt; delete data.situation_opt;
      var interests = Array.prototype.map.call(form.querySelectorAll('[name="interest_opt"]:checked'), function (i) { return i.value; });
      var situation = (form.querySelector('[name="situation_opt"]:checked') || {}).value || '';
      data.interest = interests.join(', ');
      data.situation = situation;
      var prefix = [];
      if (data.interest) prefix.push('Interesse: ' + data.interest);
      if (situation) prefix.push('Status: ' + situation);
      if (prefix.length) data.message = '[' + prefix.join(' | ') + ']' + (data.message ? '\n' + data.message : '');
      // P4: Antworten zusätzlich unter eigenen Schlüsseln (z. B. loesung, standorte); Seitenwert gewinnt nicht gegen die Auswahl
      if (form.dataset.step1Key && data.interest) data[form.dataset.step1Key] = data.interest;
      if (form.dataset.step2Key && data.situation) data[form.dataset.step2Key] = data.situation;
    }
    if ('phone' in data) {
      var pv = String(data.phone).trim();
      data.phone = (pv.charAt(0) === '+' ? '+' : '') + pv.replace(/\D/g, '');
    }
    if (form.dataset.nameSplit === '1' && typeof data.name === 'string') {
      var parts = data.name.split(/\s+/).filter(Boolean);
      data.firstName = parts[0] || '';
      data.lastName = parts.slice(1).join(' ');
    }
    if (form.dataset.sourcePageDoc === '1' && document.title) data.source_page = document.title;
    if (form.dataset.alStatic) {
      try {
        var st = JSON.parse(form.dataset.alStatic);
        Object.keys(st).forEach(function (k) { if (!Object.prototype.hasOwnProperty.call(data, k)) data[k] = st[k]; });
      } catch (e) { console.error('al-lead-form: static_json ungueltig', e); }
    }
    (form.dataset.aliases || '').split(',').forEach(function (pair) {
      var p = pair.split('>');
      if (p.length !== 2) return;
      var src = p[0].trim(), dst = p[1].trim();
      if (src && dst && Object.prototype.hasOwnProperty.call(data, src)) data[dst] = data[src];
    });
    if (form.dataset.timestamp) data[form.dataset.timestamp] = new Date().toISOString();
    return data;
  }

  function wrapperOf(form) { return form.closest('.al-lf') || form.parentElement; }
  function stateEl(form, kind) { return document.getElementById(form.id + '-' + kind) || wrapperOf(form).querySelector(kind === 'success' ? '.al-lf-success' : '.al-lf-errorstate'); }

  function show(form, kind) {
    form.style.display = 'none';
    var el = stateEl(form, kind);
    if (el) {
      el.classList.add('visible');
      focusNoScroll(el);
      ensureTopVisible(wrapperOf(form));
    }
  }

  function reset(form) {
    if (!form) return;
    form.reset();
    form.style.display = '';
    form.__alBusy = false;
    form.querySelectorAll('.error').forEach(function (el) { el.classList.remove('error'); });
    form.querySelectorAll('input, textarea, select').forEach(function (el) { el.__alDirty = false; });
    form.querySelectorAll('.al-lf-error.visible, [data-error].visible').forEach(function (el) { el.classList.remove('visible'); });
    ['success', 'error'].forEach(function (k) { var el = stateEl(form, k); if (el) el.classList.remove('visible'); });
    setHidden(form);
    if (form.__alShowStep) form.__alShowStep(1, true);
  }

  function initMultiStep(form) {
    var stepsFired = {};
    var isTouch = 'ontouchstart' in window;
    function showStep(n, silent) {
      form.querySelectorAll('.al-lf-step').forEach(function (el) {
        el.classList.toggle('active', el.dataset.step === String(n));
      });
      var num = form.querySelector('.al-lf-progress-num');
      if (num) num.textContent = n;
      form.querySelectorAll('.al-lf-progress-seg').forEach(function (seg) {
        seg.classList.toggle('done', parseInt(seg.dataset.seg, 10) <= n);
      });
      if (silent) return;
      ensureTopVisible(form.closest('.al-lf'));
      // Fokus fuer Screenreader/Tastatur in den neuen Schritt, ohne die Seite zu verschieben
      var stepEl = form.querySelector('.al-lf-step[data-step="' + n + '"]');
      var target = (n === 3 && !isTouch) ? form.querySelector('[name="name"]') : (stepEl && stepEl.querySelector('.al-lf-step-title'));
      if (target) setTimeout(function () { focusNoScroll(target); }, 60);
    }
    form.__alShowStep = showStep;
    function validateStep(n) {
      var ok = true;
      if (n === 1) ok = form.querySelectorAll('[name="interest_opt"]:checked').length > 0;
      if (n === 2) ok = form.querySelectorAll('[name="situation_opt"]:checked').length > 0;
      var err = form.querySelector('[data-step-error="' + n + '"]');
      if (err) err.classList.toggle('visible', !ok);
      return ok;
    }
    function goTo(target) {
      if (!validateStep(target - 1)) return;
      showStep(target);
      var t = track();
      if (t && t.event && !stepsFired[target]) {
        stepsFired[target] = true;
        t.event('form_step', { cta_source: 'leadform_step_' + target });
      }
    }
    form.querySelectorAll('.al-lf-next').forEach(function (btn) {
      btn.addEventListener('click', function () { goTo(parseInt(btn.dataset.next, 10)); });
    });
    form.querySelectorAll('.al-lf-back').forEach(function (btn) {
      btn.addEventListener('click', function () { showStep(parseInt(btn.dataset.back, 10)); });
    });
    form.querySelectorAll('[name="interest_opt"]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var err = form.querySelector('[data-step-error="1"]');
        if (err) err.classList.remove('visible');
        if (inp.type === 'radio') {
          setTimeout(function () {
            var s1 = form.querySelector('.al-lf-step[data-step="1"]');
            if (s1 && s1.classList.contains('active')) goTo(2);
          }, 350);
        }
      });
    });
    form.querySelectorAll('[name="situation_opt"]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var err = form.querySelector('[data-step-error="2"]');
        if (err) err.classList.remove('visible');
        setTimeout(function () {
          var s2 = form.querySelector('.al-lf-step[data-step="2"]');
          if (s2 && s2.classList.contains('active')) goTo(3);
        }, 350);
      });
    });
  }

  function bind(form) {
    if (form.__alBound) return;
    form.__alBound = true;
    var isMultiStep = form.dataset.multistep === '1';
    setHidden(form);
    if (isMultiStep) initMultiStep(form);

    form.querySelectorAll('.al-lf-input, .al-lf-textarea, .al-lf-select, input[type="checkbox"][required]').forEach(function (input) {
      // Blur-Pruefung erst, wenn das Feld bearbeitet wurde: sonst schiebt die Fehlermeldung beim blossen
      // Durchklicken (z. B. "Zurueck" im Multi-Step) das Layout und der Klick geht ins Leere.
      input.addEventListener('blur', function () { if (input.__alDirty || input.classList.contains('error')) validateField(form, input); });
      input.addEventListener(input.type === 'checkbox' || input.tagName === 'SELECT' ? 'change' : 'input', function () {
        input.__alDirty = true;
        if (input.classList.contains('error')) validateField(form, input);
      });
    });

    var wrap = wrapperOf(form);
    var retry = wrap && wrap.querySelector('[data-al-retry]');
    if (retry) retry.addEventListener('click', function () { reset(form); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.__alBusy) return;

      var isValid = true;
      form.querySelectorAll('[required]').forEach(function (input) {
        if (!validateField(form, input)) { isValid = false; trackError(input.name); }
      });
      // Telefon ist Pflicht (seit 21.10.2026) ueber [required]; E-Mail optional, aber geprueft wenn angegeben.
      var emailInput = form.querySelector('[name="email"]');
      if (emailInput && !emailInput.required && emailInput.value.trim() && !validateField(form, emailInput)) {
        isValid = false; trackError('email');
      }
      if (!isValid) {
        var firstBad = form.querySelector('[aria-invalid="true"]');
        if (firstBad) { focusNoScroll(firstBad); ensureTopVisible(firstBad.closest('.al-lf-field') || firstBad); }
        return;
      }

      // Honeypot (falls vorhanden): Bot bekommt Erfolg, es wird nichts gesendet
      var hp = form.querySelector('[data-al-hp]');
      if (hp && hp.value) { show(form, 'success'); return; }

      var data = collect(form, isMultiStep);
      var btn = form.querySelector('.al-lf-btn');
      form.__alBusy = true;
      if (btn) { btn.classList.add('loading'); btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

      fetch(form.dataset.webhook, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      }).then(function (response) {
        if (!response.ok) throw new Error('Network response was not ok');
        show(form, 'success');
        if (!form.__alTracked) {
          form.__alTracked = true;
          var t = track();
          if (t && t.formSubmit) t.formSubmit({ email: data.email, phone: data.phone, name: data.name, industry_tag: data.industry,
            form_variant: data.form_variant, segment: data.segment, standorte: data.standorte, loesung: data.loesung,
            gesellschaft: data.gesellschaft, hardware: data.hardware });
        }
      }).catch(function (error) {
        console.error('Lead form error:', error);
        show(form, 'error');
      }).then(function () {
        form.__alBusy = false;
        if (btn) { btn.classList.remove('loading'); btn.disabled = false; btn.removeAttribute('aria-busy'); }
      });
    });
  }

  // Hintergrund automatisch erkennen (surface:'auto'): erste deckende Farbe/Verlauf der Vorfahren
  function detectSurface(el) {
    for (var n = el.parentElement; n && n !== document.documentElement; n = n.parentElement) {
      var cs = getComputedStyle(n);
      var a = cs.backgroundColor.match(/[\d.]+/g);
      if (!a || (a.length > 3 && +a[3] < 0.5)) {
        a = (cs.backgroundImage || '').match(/rgba?\(([^)]+)\)/);
        a = a ? a[1].split(',') : null;
        if (!a) continue;
      }
      return (0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2] < 110) ? 'dark' : 'light';
    }
    return 'light';
  }

  function init(root) {
    (root || document).querySelectorAll('form[data-al-lead-form]').forEach(bind);
    (root || document).querySelectorAll('.al-lf-trust--auto, .al-lf-head--auto').forEach(function (el) {
      if (el.__alSurf) return;
      el.__alSurf = true;
      var dark = detectSurface(el) === 'dark';
      if (el.classList.contains('al-lf-trust--auto')) {
        el.classList.toggle('al-lf-trust--dark', dark);
        if (dark && el.classList.contains('ilf-trust')) el.classList.add('ilf-trust--dark');
      } else {
        el.classList.toggle('al-lf-head--dark', dark);
      }
    });
  }

  // lead_form_start fuer Formulare ohne alte Wrapper-Klassen (theme.liquid kennt nur .inline-lead-form/.lead-form-section)
  document.addEventListener('focusin', function (e) {
    var w = e.target.closest && e.target.closest('.al-lf');
    if (!w || w.closest('.inline-lead-form, .lead-form-section')) return;
    var t = track();
    var tag = w.querySelector('input[name="industry"]');
    if (t && t.leadFormStart) t.leadFormStart(undefined, tag ? tag.value : undefined);
  });

  window.ALLeadForm = { init: init, reset: reset };
  // Kompatibilitaet zu alten onclick-Aufrufen
  window.resetLeadForm = function (sectionId) { reset(document.getElementById('lead-form-' + sectionId)); };
  window.resetInlineLeadForm = function (formId) { reset(document.getElementById(formId)); };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
